import { normalizeRailSpacing } from 'common/utils/helpers/systemsValues';

import { INITIALIZE_VALUES } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => (dispatch) => {
    const { rail_spacing } = values;
    const normalized_rail_spacing = {
        ...rail_spacing,
        value: normalizeRailSpacing(rail_spacing),
    };
    dispatch(
        actions[INITIALIZE_VALUES]({
            ...values,
            rail_spacing: normalized_rail_spacing,
        }),
    );
};
